import { ReactNode } from 'react'
import type { StatusType } from './StatusCard'

export interface BadgeProps {
  children: ReactNode
  variant?: 'status' | 'counter' | 'pill' | 'time'
  status?: StatusType
  className?: string
}

export function Badge({
  children,
  variant = 'status',
  status = 'neutral',
  className = '',
}: BadgeProps) {
  return (
    <span
      className={`
        badge
        badge--${variant}
        badge--${status}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </span>
  )
}
